export default {
    data() {
        return {
            pagination: {
                perPage: 25,
                currentPage: 1,
            },
        }
    },

    computed: {
        currentPageStart() {
            return (this.pagination.currentPage - 1) * this.pagination.perPage;
        },

        currentPageEnd() {
            return this.currentPageStart + this.pagination.perPage;
        },

        pageLinks() {
            let pages = [];

            for (var i=1; i<=this.pages; i++) {
                pages.push(i);
            }

            return pages.slice(this.pageLinksStart, this.pageLinksEnd);
        },

        pageLinksStart() {
            if (this.pagination.currentPage <= 3) {
                return 0;
            }

            if (this.pages - this.pagination.currentPage < 2) {
                return this.pages - Math.min(this.pages, 5);
            }

            return this.pagination.currentPage - 3;
        },

        pageLinksEnd() {
            if (this.pagination.currentPage <= 3) {
                return 5;
            }

            if (this.pages - this.pagination.currentPage <= 2) {
                return this.pages;
            }

            return this.pagination.currentPage + 2;
        },
    },

    methods: {
        showPage(page) {
            this.pagination.currentPage = page;
        },

        showFirstPage() {
            this.pagination.currentPage = 1;
        },

        showLastPage() {
            this.pagination.currentPage = this.pages;
        },

        pageClasses(page) {
            return {
                'Pagination__page': true,
                'Pagination__page--is-current': page == this.pagination.currentPage,
            }
        },
    }
}